export default "__VITE_ASSET__CD9KgHHv__"